import React from "react";
import EducationKasSilme from "../Components/education/EducationKasSilme";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationKasSilmePage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <EducationKasSilme />
    </>
  );
}

export default EducationKasSilmePage;
